// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18


const loadImage = function(image) {
  const source = image.getAttribute('data-src');
  image.src = source;

  image.onload = function() {
    window.dispatchEvent(new Event('resize'));
  };
};

const loadBackground = function(element) {
  const source = element.getAttribute('data-src');
  element.style.backgroundImage = 'url(\'' + source + '\')';
};

// create config object: rootMargin and threshold
// are two properties exposed by the interface
const config = {
  rootMargin: '0px 0px 100px 0px',
  threshold: 0,
};

// register the config object with an instance
// of intersectionObserver
const observer = new IntersectionObserver(function(entries, self) {
  // iterate over each entry
  entries.forEach(function(entry) {
    // process just the images that are intersecting.
    // isIntersecting is a property exposed by the interface
    if (entry.isIntersecting) {
      // custom function that copies the path to the img
      // from data-src to src
      if (entry.target.tagName === 'IMG') {
        loadImage(entry.target);
      } else if (entry.target.tagName === 'IFRAME') {
        loadImage(entry.target);
      } else {
        loadBackground(entry.target);
      }
      // the image is now in place, stop watching
      self.unobserve(entry.target);
    }
  });
}, config);

/**
 *
 * @param {*} selector
 */
export default function(selector = '.lazyload[data-src]') {
  if ('IntersectionObserver' in window) {
    const imgs = document.querySelectorAll(selector);
    imgs.forEach(function(img) {
      observer.observe(img);
    });
  }
}
